import useDemoHelper from "./useDemoHelper";
import step61 from "../../../../../assets/demo/emergency/6.1.mp3";
import step62 from "../../../../../assets/demo/emergency/6.2.mp3";
import step63 from "../../../../../assets/demo/emergency/6.3.mp3";
import isNull from "../../../../../mixin/isNull";

window.sound = new Audio();

export default function () {
    const demoHelper = useDemoHelper();

    const flashButtonHelp = () => {
        const element = document.querySelector('[data-test="skeleton-body"]');

        if (!isNull(element)) {
            element.scrollTop = element.scrollHeight;
        }

        demoHelper.flash('[data-test="open-signature-tutorial"]', 3);
    }

    const clickButtonHelp = () => {
        demoHelper.click('[data-test="open-signature-tutorial"]');
    }

    const clickToSkipSignature = async visual => {
        if (!visual) {
            demoHelper.flash('[data-test="button-skip-signature"]', 3);

            await demoHelper.sleep(3000);

            document.getElementsByClassName("MuiFab-warning")[0]?.click();
            return;
        }

        demoHelper.click('[data-test="button-skip-signature"]');
    }

    const flashUploadQuotation = () => {
        const element = document.querySelector('[data-test="skeleton-body"]');
        element.scrollTop = element.scrollHeight;

        demoHelper.flash('[data-test="button-upload-quotation"]', 5);
    }

    return {
        async launch(audio = true, visual = true) {
            demoHelper.lockInteract();

            // 11 seconds
            window.sound.src = step61;
            window.sound.play();

            await demoHelper.sleep(8000);

            flashButtonHelp();

            await demoHelper.sleep(4000);

            clickButtonHelp();

            // 7 seconds
            window.sound.src = step62;
            window.sound.play();

            await demoHelper.sleep(4000);

            clickToSkipSignature(visual);

            await demoHelper.sleep(1000);

            await demoHelper.sleep(3000);

            if (visual) {
                // 4 seconds
                window.sound.src = step63;
                window.sound.play();

                flashUploadQuotation();
            }

            demoHelper.unlockInteract();
        }
    }
}